<template>
  <div>
    <!-- 默认标题 -->
    <div class="title title-text resume-editor-plate-title" :style="{ 'border-bottom-color': formatInfo.title_color }" v-if="formatInfo.title_format==='default'">
      <span>{{title}}</span>
    </div>
    <!-- 条形 -->
    <div class="strip-title-wrapper" v-if="formatInfo.title_format==='strip'">
      <div class="line" :style="{background: formatInfo.title_color}"></div>
      <span class="title" :style="{color: formatInfo.title_color}">{{ title }}</span>
      <div class="bg" :style="{background: formatInfo.title_color}"></div>
    </div>
    <!-- 标签 -->
    <div class="tag-title-wrapper" v-if="formatInfo.title_format==='tag'">
      <div class="real">
        <span class="title">{{ title }}</span>
        <div class="bg-top" :style="{borderBottomColor: formatInfo.title_color}"></div>
        <div class="bg-bottom" :style="{borderBottomColor: formatInfo.title_color}"></div>
      </div>
      <div class="line" :style="{background: formatInfo.title_color}"></div>
    </div>
    <!-- 图标 -->
    <div class="icon-title-wrapper" v-if="formatInfo.title_format==='icon'">
    <i :class="['icon', 'iconfont', `iconcv-title-icon-${modelType}`]" :style="{color: formatInfo.title_color}"></i>
    <span class="title" :style="{color: formatInfo.title_color}">{{ title }}</span>
    <div class="line" :style="{background: formatInfo.title_color}"></div>
  </div>
  </div>
</template>

<script>


	export default {
		name: 'file-cv-title',
    props: {
			formatInfo: {
				type: Object,
        default: ()=>{}
      },
      title: {
				type: String,
        default: ''
      },
      modelType: {
				type: String,
        default: ''
      },
    },
		data () {
			return {

			}
		},
    created () {
		  
    },
		methods: {
		}
	}
</script>

<style lang="scss" scoped>
  @import './styles/file-cv.scss';

  .strip-title-wrapper {
    display: flex;
    align-items: center;
    position: relative;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-left: 20px;
    margin-bottom: 8px;
    .line {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 4px;
      height: 100%;
      background: #404040;
    }
    .title {
      display: inline-block;
      color: #404040;
      font-size: 16px ;
      font-weight: 600;
      border-bottom: 0 !important;
    }
    .bg {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      width: 100%;
      height: 100%;
      background: #404040;
      opacity: 0.05;
    }
  }
  .tag-title-wrapper {
    display: flex;
    position: relative;
    margin-bottom: 8px;
    .real {
      display: flex;
      align-items: center;
      position: relative;
      bottom: 0;
      height: 34px;
      padding-left: 20px;
      padding-right: 30px;
    }
    .title {
      position: relative;
      z-index: 3;
      display: inline-block;
      color: #ffffff !important;
      font-size: 16px;
      font-weight: 600;
      line-height: 1;
      border-bottom: 0 !important;
    }
    .bg-top {
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 2;
      width: 100%;
      height: 0;
      border-bottom: 34px solid #404040;
      border-right: 10px solid transparent;
    }
    .bg-bottom {
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 1;
      width: calc(100% + 12px);
      height: 0;
      border-bottom: 30px solid #404040;
      border-right: 10px solid transparent;
      opacity: 0.12;
    }
    .line {
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 0;
      width: 100%;
      height: 1px;
      background: #404040;
      opacity: 0.12;
    }
  }

  .icon-title-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .icon {
      font-size: 18px;
      margin-right: 8px;
    }
    .title {
      display: inline-block;
      color: #404040;
      font-size: 16px;
      font-weight: 600;
      word-break: keep-all;
      white-space: nowrap;
      margin-right: 10px;
      border-bottom: 0 !important;
    }
    .line {
      width: 100%;
      height: 1px;
      background: #404040;
      opacity: 0.12;
    }
  }
</style>
